import { render, staticRenderFns } from "./stepSaldoCartoesManual.vue?vue&type=template&id=0b644cf6"
import script from "./stepSaldoCartoesManual.vue?vue&type=script&lang=ts"
export * from "./stepSaldoCartoesManual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports